// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.line-graph-widget[data-v-118857f4] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n> div {\n    position: relative;\n    height: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
